import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { NavController } from '@ionic/angular';
import { LocaldataService } from '../../service/localdata/localdata.service';

@Component({
  selector: 'app-filelist-root',
  templateUrl: './filelist-root.component.html',
  styleUrls: ['./filelist-root.component.scss'],
})
export class FilelistRootComponent implements OnInit, OnDestroy {

  private folderId: any = null;
  private folderStructure: any = [];
  private folderDepth:number = 0;



  constructor(private localData: LocaldataService, private route: ActivatedRoute, private router: Router) {

    //this.generateFolderStructure();
    

    /*this.route.params.subscribe(params => {
      
      console.log(params);
      if(params.id){
        this.folderId = params.id
      }
      
    });
      this.route.queryParams.subscribe(params => {
        console.log(params);
      });*/
   }




  ngOnInit() {
    //console.log(this.localData.displayNumber)
  }
  ngOnDestroy(){

  }

  ionViewWillEnter(){
    //this.generateFolderStructure();console.log('will enter');
  }

  openTheFolder(obj){
    this.localData.breadcrumb.push({
      "id":obj.id,
      "displayName": obj.displayname
    });



    let navigationExtras: NavigationExtras = {
      queryParams: {
        special: JSON.stringify(123)
      }
    };
console.log(obj.id)

    this.router.navigate(['dueslag', obj.id]).catch(err=>{console.log('error', err)});

    //this.navCtrl.navigateRoot
    //this.navCtrl.push(FolderPage, {folderId: obj.id, folderName: obj.displayname, breadcrumb: this.breadcrumb, folderDepth: this.folderDepth+1});
    //this.router.navigateByUrl(path);
  }

}